const Data = {
  WebsiteTitle: "Isla's Portfolio",
  HeaderTitle: "Isla's Portfolio",
  FooterText: "© 2026 Isla's Portfolio. All rights reserved.",
  AboutEmail: "Your Email Address",
  AboutEmailSubject: "Subject of the Email",
  AboutHeading: "About Me",
  AboutTextParagraph1:
    "Just a passionate 11-year-old artist exploring the world through colors and creativity.",
  AboutTextParagraph2:
    "I love to paint, draw, and bring my imagination to life on canvas. Welcome to my colorful world!",
  AboutButtonText: "Say Hey!",
};

export default Data;
